import { isNil } from '@lucidlink/tscore';
import { NotImplementedError } from '#common/types';
import { bigIntToLong, longToBigInt } from '#common/util';
import { EpochRequestMsg, ServiceBaseProto, } from '#websocket/client/proto';
const EPOCH_REQUEST = '.EpochRequestMsg.epochRequest';
const EPOCH_RESPONSE = '.EpochResponseMsg.epochResponse';
export class EpochRequest {
    operation;
    nodeId;
    clientEpoch;
    clientConnection;
    destination;
    constructor(operation, nodeId, clientEpoch, clientConnection, destination) {
        this.operation = operation;
        this.nodeId = nodeId;
        this.clientEpoch = clientEpoch;
        this.clientConnection = clientConnection;
        this.destination = destination;
    }
    createMessage(requestId, version) {
        return ServiceBaseProto.RequestMsg.create({
            id: bigIntToLong(requestId),
            versionMajor: version.major,
            versionMinor: version.minor,
            versionBuild: version.build,
            [EPOCH_REQUEST]: EpochRequestMsg.create({
                operation: this.operation,
                nodeId: this.nodeId,
                clientEpoch: bigIntToLong(this.clientEpoch),
                // eslint-disable-next-line no-restricted-syntax -- Cause this rule is the slamming screen door
                clientConnection: this.clientConnection ? bigIntToLong(this.clientConnection) : null,
            }),
        });
    }
    getDestination() {
        return this.destination;
    }
    createResponse(_responseMessage) {
        throw new NotImplementedError();
    }
}
export class EpochResponse {
    resultCode;
    hubConnection;
    prevHubEpoch;
    constructor(response) {
        const responseMsgObject = ServiceBaseProto.ResponseMsg.toObject(response);
        const epochResponseMsg = responseMsgObject[EPOCH_RESPONSE];
        this.resultCode = epochResponseMsg.resultCode;
        const hubConnection = epochResponseMsg.hubConnection;
        const prevHubEpoch = epochResponseMsg.prevHubEpoch;
        if (!isNil(hubConnection)) {
            this.hubConnection = longToBigInt(hubConnection);
        }
        if (!isNil(prevHubEpoch)) {
            this.prevHubEpoch = longToBigInt(prevHubEpoch);
        }
    }
}
